import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6bb52775"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-header" }
const _hoisted_2 = { class: "heading" }
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "app-header__user-info" }
const _hoisted_5 = { class: "text-weight-medium" }

import { ref } from 'vue';
import UserInfoDropdown from './UserInfoDropdown.vue';
import UserAvatar from './UserAvatar.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppHeader',
  props: {
    title: {},
    userName: {},
    userEmail: {},
    logoutLabel: {},
    imageUrl: {}
  },
  setup(__props: any) {



const isDropdownOpen = ref(false);

const closeDropdown = () => {
	if (isDropdownOpen.value) isDropdownOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default"),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "app-header__user-info__btn",
          type: "button",
          tabindex: "0",
          "aria-label": "user info",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isDropdownOpen.value = !isDropdownOpen.value))
        }, [
          _createVNode(UserAvatar, {
            "user-name": _ctx.userName,
            "image-url": _ctx.imageUrl,
            class: "mr-2"
          }, null, 8, ["user-name", "image-url"]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.userName), 1)
        ]),
        (isDropdownOpen.value)
          ? (_openBlock(), _createBlock(UserInfoDropdown, {
              key: 0,
              "user-name": _ctx.userName,
              "user-email": _ctx.userEmail,
              "logout-label": _ctx.logoutLabel,
              onLogout: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('logout')))
            }, null, 8, ["user-name", "user-email", "logout-label"]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_click_outside, closeDropdown]
      ])
    ])
  ]))
}
}

})